import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { closeModal } from '../actions/modal-actions';

const useCloseModal = () => {
  const dispatch = useDispatch();
  return useCallback((...args) => dispatch(closeModal(...args)), [dispatch]);
};

export default useCloseModal;
